import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { ADDTL_TAX_FEES_FORM } from '../../constants/formNames';
import AddtlTaxFeesForm from './AddtlTaxFeesForm';

class AddtlTaxFeesFormContainer extends Component {
  render () {
    return (
      <AddtlTaxFeesForm
        {...this.props}
      />
    );
  }
}

AddtlTaxFeesFormContainer.propTypes = {
  currency: PropTypes.string
};

const selector = formValueSelector(ADDTL_TAX_FEES_FORM);

function mapStateToProps (state) {
  const addOnFeeValues = selector(state, 'fees');

  return {
    addOnFeeValues
  };
}

export default connect(mapStateToProps)(AddtlTaxFeesFormContainer);
